import { getPrintItemKey } from "./catalogBarcodePrintItems";

export const PRINT_QUANTITY_MODES = {
  ONE_PER_VARIANT: "one-per-variant",
  MATCH_ON_HAND: "match-on-hand",
};

const toNonNegativeInteger = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;
  return Math.max(0, Math.floor(numeric));
};

/**
 * Units physically in the store for this label. Labels go on every pair on the
 * shelf — including pairs reserved for an order — so this is on-hand stock,
 * never "available to sell".
 */
export const getOnHandForPrintItem = (item) => {
  const candidates = [
    item?.onHand,
    item?.inventory?.summary?.onHand,
    item?.inventory?.onHand,
    item?.totalStock,
    item?.stock,
  ];

  for (const candidate of candidates) {
    const normalized = toNonNegativeInteger(candidate);
    if (normalized != null) return normalized;
  }

  const levels = item?.inventory?.aggregateByLocation;
  if (Array.isArray(levels) && levels.length) {
    return levels.reduce((sum, level) => sum + (toNonNegativeInteger(level?.onHand) || 0), 0);
  }

  return 0;
};

export const getCopiesForQuantityMode = (item, mode) =>
  mode === PRINT_QUANTITY_MODES.MATCH_ON_HAND ? getOnHandForPrintItem(item) : 1;

export const buildCopiesByQuantityMode = (items, mode) =>
  (Array.isArray(items) ? items : []).reduce((accumulator, item) => {
    if (!item) return accumulator;
    accumulator[getPrintItemKey(item)] = getCopiesForQuantityMode(item, mode);
    return accumulator;
  }, {});

export const normalizeCopiesInputValue = (value, fallback = 0) => {
  const normalized = toNonNegativeInteger(value);
  return normalized == null ? fallback : normalized;
};
